// 校验是否为手机号
const isPhone = (value) => {
  //使用正则表达式进行验证手机号码
  if (!/^1[3456789]\d{9}$/.test(value)) {
    return false
  } else {
    return true
  }
}

export default {
  isPhone
}